export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=a615b1fa&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/faq/category/index.vue?vue&type=template&id=a615b1fa&
// module id = 1087
// module chunks = 0